import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import Organizations from "@/views/Organizations.vue";
import Users from "@/views/Users.vue";
import Reports from "@/views/Reports.vue";
import SymetriReports from "@/views/SymetriReports.vue";
import RoutePath from "@/router/constants/RoutePath";

Vue.use(VueRouter);
Vue.use(Vuex);

const routes: any = [
  {
    path: RoutePath.organizations,
    component: Organizations,
    meta: { requiresAuth: true },
  },
  {
    path: RoutePath.users,
    component: Users,
    meta: { requiresAuth: true },
  },
  {
    path: RoutePath.reports,
    component: Reports,
    meta: { requiresAuth: true },
  },
  {
    path: RoutePath.symetrireports,
    component: SymetriReports,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
